import type { SettingsSurface } from './Settings'
import { SellerStoresPage } from '../seller/stores/SellerStoresPage'
import { useT } from '../../i18n'
import { sellerStoresI18n } from '../../i18n/seller/stores'

export function StoreIntegrations({ surface }: { surface: SettingsSurface }) {
  void surface
  const t = useT(sellerStoresI18n)
  return (
    <section aria-label={t.page.connectedTitle}>
      <SellerStoresPage />
    </section>
  )
}
